import { useTranslation } from "react-i18next";
import { Row, Col } from '../common/components/Grid';
import TextInput from "../common/components/TextInput";

const GridInput = ({ id, gridx, gridy, placeholder, disabled, required, readonly, onChange, live }) => {
    const { t } = useTranslation();

    const handleChange = (field, value) => {
        onChange({ [field]: value });
    }

    const handlePaste = e => {
        let data = e.clipboard.getData('text');
        data = data?.split(',');
        if (data?.length === 2) {
            e.preventDefault();
            onChange({ gridx: data[0], gridy: data[1] });
            return;
        }
        return;
    }

    return <Row id={`${id}_gridInput`}>
        <Col>
            <TextInput id={`${id}_gridX`} value={gridx} live={live} placeholder={placeholder?.x ?? t('gridX')} disabled={disabled} required={required} readonly={readonly} onPaste={handlePaste} onChange={text => handleChange('gridx', text)} aria-label={placeholder?.x ?? t('gridX')}></TextInput>
        </Col>
        <Col>
            <TextInput id={`${id}_grixY`} value={gridy} live={live} placeholder={placeholder?.y ?? t('gridY')} disabled={disabled} required={required} readonly={readonly} onPaste={handlePaste} onChange={text => handleChange('gridy', text)} aria-label={placeholder?.y ?? t('gridY')}></TextInput>
        </Col>
    </Row>
}

export default GridInput;